import { CancelTokenSource } from 'axios'
import { prepagaPrecios } from './bff/bffClient';

/**
 * Paso 2 Prepaga: obtiene precios vía el BFF (POST {BFF}/prepaga/precios).
 * El BFF devuelve un OBJETO { sumaAsegurada, items[] } (shape DISTINTO de AP, NO array).
 * Lo adaptamos al envelope { data: { api_status, api_data } } que consume Precios,
 * preservando intacto el objeto en api_data (la página lee api_data.items).
 * El recaptcha lo mintea el bffClient (header `g-recaptcha-response`), por eso
 * `captchaToken` ya no se usa. `cancelTokenSource` se mantiene por compatibilidad de firma.
 */
const cotizarPlanMedico = async (
    compania: string,
    idContacto: string,
    emisionHabilitada: string,
    token: string,
    _cancelTokenSource: CancelTokenSource,
    _captchaToken?: string
): Promise<any> => {
    try {
        const apiData = await prepagaPrecios({
            compania,
            idContacto,
            token,
            emisionHabilitada,
        });
        return { data: { api_status: 200, api_data: apiData } };
    } catch (error) {
        console.error('Error en la solicitud', error);
        return error;
    }
};

export default cotizarPlanMedico;
